import { render } from "./ConfirmEmailStep1.vue?vue&type=template&id=332b67a4"
import script from "./ConfirmEmailStep1.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailStep1.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bylex_platform/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__